module.exports = __webpack_public_path__ + "img/class3.0f36ea69.jpg";